<template>
  <div class="md-layout">
    <partners-list />
    <div class="md-layout md-layout-item md-size-100">
      <div class="ml-auto">
        <md-button
          @click.prevent="$router.push({name:'partners'})"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:0px"
        >{{$t('Go to partners')}}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/util/axios";
import { mapGetters, mapActions } from "vuex";
import PartnersList from "@/pages/authenticated/components/Partners/PartnersList";

export default {
  components: { PartnersList },

  data() {
    return {};
  }
};
</script>
